import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';

import api from '../../../api/axios';
import { IApiResponseError, IApiState } from '../../../types/api';
import { ITransactionMandateV2 } from '../../../types/transactionMandate';
import { RootState } from '../..';

interface IGetOutletTransactionMandatesResponse {
  status?: boolean;
  message?: string;
  data?: ITransactionMandateV2[];
  errors?: IApiResponseError[];
}

const initialState: IApiState<IGetOutletTransactionMandatesResponse> = {
  value: null,
  status: 'idle',
  error: '',
};

export const getOutletTransactionMandatesAsync = createAsyncThunk(
  'outletTransactionMandates',
  async (_, { rejectWithValue, getState }) => {
    try {
      const state = getState() as RootState;

      const accessToken = state.auth.value?.data?.token?.accessToken;

      const businessId =
        localStorage.getItem('businessId') ||
        state.auth.value?.data?.user?.businesses?.[0]?.id;

      const config = {
        headers: {
          Authorization: `Token ${accessToken}`,
          'X-Business-Id': businessId,
        },
      };

      const { data } = await api.get('/transaction/outlet-mandates', config);

      return data;
    } catch (err) {
      const error = err as AxiosError<IApiResponseError>;

      return rejectWithValue(error.response?.data);
    }
  }
);

export const outletTransactionMandatesGetSlice = createSlice({
  name: 'outletTransactionMandates/get',
  initialState,
  reducers: {
    resetGetOutletTransactionMandates: (state) => {
      state.value = null;
      state.status = 'idle';
      state.error = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getOutletTransactionMandatesAsync.pending, (state) => {
        state.status = 'loading';
        state.error = '';
      })
      .addCase(getOutletTransactionMandatesAsync.fulfilled, (state, action) => {
        state.status = 'success';
        state.value = action.payload as IGetOutletTransactionMandatesResponse;
      })
      .addCase(getOutletTransactionMandatesAsync.rejected, (state, action) => {
        state.status = 'failed';
        state.value = action.payload as IGetOutletTransactionMandatesResponse;
        state.error = action.error.message;
      });
  },
});

export const { resetGetOutletTransactionMandates } =
  outletTransactionMandatesGetSlice.actions;

export default outletTransactionMandatesGetSlice.reducer;
